export enum EnvironmentName {
  Development = 'development',
  Staging = 'staging',
  Production = 'production',
}
